import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import BlendedService from "../Service/BlendedService"; // Import the service

const AddBlendedCourse = () => {
  const location = useLocation();
  const history = useHistory();
  const { user } = location.state || {};
  const [blendedProgramName, setProgramName] = useState("");
  const [programWDCourseCode, setProgramWDCourseCode] = useState("");
  const [rows, setRows] = useState([
    {
      id: 1,
      moduleName: "",
      moduleWDCourseCode: "",
      description: "",
      duration: "",
      numOfSMEConnects: "",
      track: user.track,
    },
  ]);
  const [rowCounter, setRowCounter] = useState(2);

  // Validation functions with alert boxes
  const validateField = (fieldName, value, rowId = null) => {
    let errorMessage = "";

    switch (fieldName) {
      case "Program Name":
        if (!value || value.trim() === "") {
          errorMessage = "Program name is required";
        } else if (value.trim().length < 3) {
          errorMessage = "Program name must be at least 3 characters long";
        }
        break;

      case "Program WD Course Code":
        if (!value || value.trim() === "") {
          errorMessage = "Program WD Course Code is required";
        } else if (value.trim().length < 2) {
          errorMessage = "Program WD Course Code must be at least 2 characters long";
        }
        break;
      
      case "Module Name":
        if (!value || value.trim() === "") {
          errorMessage = "Module name is required";
        } else if (value.trim().length < 2) {
          errorMessage = "Module name must be at least 2 characters long";
        }
        break;

      case "Module WD Course Code":
        if (!value || value.trim() === "") {
          errorMessage = "Module WD Course Code is required";
        } 
        //else if (value.trim().length < 2) {
        //   errorMessage = "Module WD Course Code must be at least 2 characters long";
        // }
        break;
      
      case "Description":
        if (!value || value.trim() === "") {
          errorMessage = "Description is required";
        } else if (value.trim().length < 10) {
          errorMessage = "Description must be at least 10 characters long";
        }
        break;
      
      case "Duration":
        if (!value || value === "") {
          errorMessage = "Duration is required";
        } else {
          const num = Number(value);
          if (isNaN(num) || num <= 0) {
            errorMessage = "Duration must be greater than 0";
          } else if (num > 100) {
            errorMessage = "Duration cannot exceed 100 hours";
          }
        }
        break;
      
      case "SME Connects":
        if (!value || value === "") {
          errorMessage = "Number of SME connects is required";
        } else {
          const num = Number(value);
          if (isNaN(num) || num <= 0) {
            errorMessage = "Number of SME connects must be greater than 0";
          } else if (num > 50) {
            errorMessage = "Number of SME connects cannot exceed 50";
          }
        }
        break;
    }

    if (errorMessage) {
      alert(errorMessage);
      return false;
    }
    return true;
  };

  const validateAllFields = () => {
    // Validate program name
    if (!validateField("Program Name", blendedProgramName)) {
      return false;
    }

    // Program WD Course Code is optional - no validation needed

    // Validate all rows
    for (let row of rows) {
      if (!validateField("Module Name", row.moduleName, row.id)) return false;
      if (!validateField("Module WD Course Code", row.moduleWDCourseCode, row.id)) return false;
      if (!validateField("Description", row.description, row.id)) return false;
      if (!validateField("Duration", row.duration, row.id)) return false;
      if (!validateField("SME Connects", row.numOfSMEConnects, row.id)) return false;
    }

    return true;
  };

  const handleChange = (id, field, value) => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  const handleProgramNameChange = (value) => {
    setProgramName(value);
  };

  const handleProgramWDCourseCodeChange = (value) => {
    setProgramWDCourseCode(value);
  };

  const addRow = () => {
    // Validate current rows before adding new one
    for (let row of rows) {
      if (!validateField("Module Name", row.moduleName, row.id)) return;
      if (!validateField("Module WD Course Code", row.moduleWDCourseCode, row.id)) return;
      if (!validateField("Description", row.description, row.id)) return;
      if (!validateField("Duration", row.duration, row.id)) return;
      if (!validateField("SME Connects", row.numOfSMEConnects, row.id)) return;
    }

    setRows((prev) => [
      ...prev,
      {
        id: rowCounter,
        moduleName: "",
        moduleWDCourseCode: "",
        description: "",
        duration: "",
        numOfSMEConnects: "",
        track: user?.track || "",
      },
    ]);
    setRowCounter((prev) => prev + 1);
  };

  const removeRow = (id) => {
    if (rows.length > 1) {
      setRows((prev) => prev.filter((row) => row.id !== id));
    } else {
      alert("Cannot remove the last module. At least one module is required.");
    }
  };

  // Check if all fields are filled (for button states)
  const isFormValid = () => {
    if (!blendedProgramName.trim()) return false;
    // programWDCourseCode is optional - no check needed
    
    return rows.every(row => 
      row.moduleName.trim() !== "" &&
      row.moduleWDCourseCode.trim() !== "" &&
      row.description.trim() !== "" &&
      row.duration !== "" &&
      Number(row.duration) > 0 &&
      row.numOfSMEConnects !== "" &&
      Number(row.numOfSMEConnects) >= 0
    );
  };

  const saveData = async () => {
    // Validate all fields with alert boxes
    if (!validateAllFields()) {
      return; // Validation failed, alerts already shown
    }

    const payload = {
      blendedProgramName: blendedProgramName.trim(),
      programWDCourseCode: programWDCourseCode.trim() || "N/A",
      track: user?.track || "",
      modules: rows.map(row => ({
        moduleName: row.moduleName.trim(),
        moduleWDCourseCode: row.moduleWDCourseCode.trim(),
        description: row.description.trim(),
        duration: Number(row.duration),
        numOfSMEConnects: Number(row.numOfSMEConnects)
      })),
    };

    try {
      const response = await BlendedService.saveCourse(payload);
      alert("Course saved successfully!");
      console.log("Saved:", response);
      console.log("Saved:", payload);
      
      // Reset form after successful save
      setProgramName("");
      setProgramWDCourseCode("");
      setRows([{
        id: 1,
        moduleName: "",
        moduleWDCourseCode: "",
        description: "",
        duration: "",
        numOfSMEConnects: "",
        track: user?.track || "",
      }]);
      setRowCounter(2);

      // Redirect to BlendedCourseManagementPage
      history.push({
        pathname: "/admin/blended-course-management",
        state: { user }
      });
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Failed to save course: " + (error.message || "Unknown error"));
    }
  };

  return (
    <div>
      <br/>
      <h2 className="text-2xl w-1/3 mx-auto font-semibold mb-4 text-center">Add Blended Course</h2>
      <br/>
      <div className="w-11/12 mx-auto p-8 bg-white rounded-lg shadow-md">
        {/* Program Name, Course Code and Track Row */}
        <div className="mb-6 flex gap-6">
          {/* Program Name Input */}
          <div className="flex-1">
            <label className="block text-gray-700 text-sm font-semibold mb-2">
              Program Name: <span style={{color: 'red'}}>*</span>
            </label>
            <input
              type="text"
              value={blendedProgramName}
              onChange={(e) => handleProgramNameChange(e.target.value)}
              placeholder="Enter program name"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Program WD Course Code Input */}
          <div className="flex-1">
            <label className="block text-gray-700 text-sm font-semibold mb-2">
              Program WD Course Code: <span className="text-gray-500 text-xs">(Optional)</span>
            </label>
            <input
              type="text"
              value={programWDCourseCode}
              onChange={(e) => handleProgramWDCourseCodeChange(e.target.value)}
              placeholder="Enter program WD course code (optional)"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Track Display */}
          <div className="flex-1">
            <label className="block text-gray-700 text-sm font-semibold mb-2">
              Track:
            </label>
            <input
              type="text"
              value={user?.track || ""}
              readOnly
              className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 cursor-not-allowed text-gray-600"
              placeholder="Track will be automatically assigned"
            />
          </div>
        </div>

        {/* Table */}
        <div className="mb-6 overflow-x-auto flex justify-center">
          <table className="w-full max-w-5xl border-collapse bg-white border border-gray-300 rounded-lg overflow-hidden shadow-sm">
            <thead>
              <tr className="bg-gray-200 text-gray-600">
                <th className="px-4 py-3 text-left font-semibold border-b">#</th>
                <th className="px-4 py-3 text-left font-semibold border-b">
                  Module Name <span style={{color: '#ffeb3b'}}>*</span>
                </th>
                <th className="px-4 py-3 text-left font-semibold border-b">
                  Module WD Course Code <span style={{color: '#ffeb3b'}}>*</span>
                </th>
                <th className="px-4 py-3 text-left font-semibold border-b">
                  Description <span style={{color: '#ffeb3b'}}>*</span>
                </th>
                <th className="px-4 py-3 text-left font-semibold border-b">
                  Duration (hours) <span style={{color: '#ffeb3b'}}>*</span>
                </th>
                <th className="px-4 py-3 text-left font-semibold border-b">
                  No. of SME Connects <span style={{color: '#ffeb3b'}}>*</span>
                </th>
                <th className="px-4 py-3 text-center font-semibold border-b">Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50 border-b border-gray-200">
                  <td className="px-4 py-3 text-center">{row.id}</td>
                  <td className="px-4 py-3">
                    <input
                      type="text"
                      value={row.moduleName}
                      onChange={(e) =>
                        handleChange(row.id, "moduleName", e.target.value)
                      }
                      placeholder="Enter module name"
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </td>
                  <td className="px-4 py-3">
                    <input
                      type="text"
                      value={row.moduleWDCourseCode}
                      onChange={(e) =>
                        handleChange(row.id, "moduleWDCourseCode", e.target.value)
                      }
                      placeholder="Enter module WD course code"
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </td>
                  <td className="px-4 py-3">
                    <textarea
                      value={row.description}
                      onChange={(e) =>
                        handleChange(row.id, "description", e.target.value)
                      }
                      placeholder="Enter module description"
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[60px] resize-vertical"
                      required
                    />
                  </td>
                  <td className="px-4 py-3">
                    <input
                      type="number"
                      value={row.duration}
                      onChange={(e) =>
                        handleChange(row.id, "duration", e.target.value)
                      }
                      placeholder="Hours"
                      min="0.1"
                      max="100"
                      step="0.1"
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </td>
                  <td className="px-4 py-3">
                    <input
                      type="number"
                      value={row.numOfSMEConnects}
                      onChange={(e) =>
                        handleChange(row.id, "numOfSMEConnects", e.target.value)
                      }
                      placeholder="Count"
                      min="0"
                      max="50"
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </td>
                  <td className="px-4 py-3 text-center">
                    <button
                      onClick={() => removeRow(row.id)}
                      disabled={rows.length === 1}
                      className="px-3 py-1 bg-red-500 text-white text-sm font-semibold rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:bg-gray-400 disabled:cursor-not-allowed"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4 justify-center pt-6 border-t border-gray-200">
          <button
            type="button"
            onClick={addRow}
            disabled={!isFormValid()}
            className="px-4 py-2 bg-green-500 text-white font-semibold rounded-lg shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            + Add Module
          </button>
          <button
            type="button"
            onClick={saveData}
            className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            Save Course
          </button>
          <button
            type="button"
            onClick={() => history.push({
              pathname: "/admin/blended-course-management",
              state: { user }
            })}
            className="px-4 py-2 bg-gray-500 text-white font-semibold rounded-lg shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBlendedCourse;